var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Area',{staticStyle:{"max-width":"350px"},attrs:{"value":_vm.valueProp,"level":3,"data-type":"name"},on:{"on-change":_vm.handleChange}})}
var staticRenderFns = []

export { render, staticRenderFns }